module.exports = __webpack_public_path__ + "img/icon_contact_m.782f9876.png";